module.exports = __webpack_public_path__ + "static/media/icon-character__nicolae-ceausescu.c68c02e3.svg";